import { useEffect, useMemo } from "react";
import useNotificationStore, {
  type NotificationSeverity,
} from "../../../setup/store/useNotificationStore";
import { ToastContainer, toast } from "react-toastify";
import "./scss/index.scss";
import { useColorScheme, useMediaQuery } from "@mui/material";

const Notification = () => {
  const { notify, msg, severity, hideNotif } = useNotificationStore();
  const {mode} = useColorScheme();
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  // Fire the toast only when `notify` flips truthy, reading the current
  // msg/severity at that moment; msg/severity/hideNotif are intentionally
  // not deps so a toast isn't re-shown if they change while notify stays set.
  useEffect(() => {
    if (!notify) return;
    if (notify) {
      trigger(msg, severity);
    }
    setTimeout(() => {
      hideNotif();
    }, 3000);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notify]);

  // The store derives `severity` from the old success boolean when a caller
  // does not pass one, so this switch covers every existing call site too.
  const trigger = (msg: string, severity: NotificationSeverity) => {
    if (severity === 'success') toast.success(msg);
    else if (severity === 'warning') toast.warning(msg);
    else toast.error(msg);
  };
  
  const currentMode = useMemo(() => {
    if(mode == 'system'){
      return prefersDarkMode ? 'dark' : 'light';
    }
    else return mode;
  }, [mode, prefersDarkMode]);

  return (
      <ToastContainer theme={currentMode}/> 
  );
};

export default Notification;
